import { FETCH_USER_DATA_FULFILLED, SET_LOCALE } from './actions';

import type { User } from '@/types/user';

export interface UserAction {
  type: string;
  payload?: User | string;
}

const getInitialLocale = (): string | undefined => {
  try {
    return globalThis.localStorage.getItem('locale') ?? undefined;
  } catch {
    return undefined;
  }
};

const initialLocale = getInitialLocale();

export const initialState: User = {
  _id: '',
  uuid: '',
  organizationId: '',
  roles: [],
  productIds: [],
  email: '',
  activated: false,
  createdByEmail: '',
  idm: '',
  organization: {
    _id: '',
    enterpriseName: '',
    productIds: [],
    marketplaceItemIds: [],
    schemaVersion: 1,
    createdAt: '',
    updatedAt: '',
    type: '',
    __v: 0,
  },
  role: '' as unknown as User['role'],
  beautifiedRole: '',
  ...(initialLocale ? { locale: initialLocale } : {}),
};

const beautifyRole = (role: string): string =>
  role
    .toLowerCase()
    .split('_')
    .map((el: string) => (el ? (el[0]?.toUpperCase() ?? '') + el.substring(1) : ''))
    .join(' ');

const userReducer = (state: User = initialState, action: UserAction): User => {
  if (action.type === FETCH_USER_DATA_FULFILLED) {
    const payload = action.payload as User | undefined;
    return {
      ...state,
      ...payload,
      beautifiedRole: beautifyRole(payload?.roles?.[0] ?? ''),
    };
  }

  if (action.type === SET_LOCALE) {
    return { ...state, locale: action.payload as string };
  }

  return state;
};

export { userReducer };
